import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateTicket,
  setCurrentTicket,
  clearCurrentTicket
} from '@store/actions/outboundCallingActions';

/**
 * Custom hook for managing ticket details and updates
 * Simplified to handle only ticket detail operations (not list fetching)
 */
export const useTickets = () => {
  const dispatch = useDispatch();

  // Select current ticket being viewed/edited
  const currentTicket = useSelector((state) => state.outboundCalling?.currentTicket?.ticket);
  const { userId: agentId } = useSelector((state) => state?.auth?.user || {});

  const isUpdatingTicket = useSelector(
    (state) => state.outboundCalling?.currentTicket?.isUpdating || false
  );

  /**
   * Update ticket (status, priority, etc.)
   */
  const handleUpdateTicket = useCallback(
    (ticketId, updates) => {
      return dispatch(
        updateTicket({
          ticketId,
          agentId,
          updates
        })
      );
    },
    [dispatch]
  );

  /**
   * Set current ticket (open ticket modal)
   */
  const openTicket = useCallback(
    (ticket) => {
      dispatch(setCurrentTicket(ticket));
    },
    [dispatch]
  );

  /**
   * Clear current ticket (close ticket modal)
   */
  const closeTicket = useCallback(() => {
    dispatch(clearCurrentTicket());
  }, [dispatch]);

  return {
    // Current ticket data
    currentTicket,

    // Loading states
    isUpdatingTicket,

    // Actions
    updateTicket: handleUpdateTicket,
    openTicket,
    closeTicket
  };
};

export default useTickets;
